export default __webpack_public_path__ + "static/aliado1-67166bf0727ae09ded36b8b75148e066.webp";